import { Component } from '@angular/core';

@Component({
  selector: 'itl-desktop-column-layout',
  templateUrl: './desktop-column-layout.component.html',
  styleUrls: ['./desktop-column-layout.component.scss'],
})
export class DesktopColumnLayoutComponent {}
